export class EdIntersectionObserver {
	/**
	 * Init the class
	 *
	 * @param {HTMLElement} rootEl     The root element of the block
	 * @param {HTMLElement} selectorEl The selector element of the block
	 */
	constructor(rootEl, selectorEl) {
		// Define classes, selectors, and magic
		this.rootEl = rootEl;
		this.selectorEl = selectorEl;
		this.createObserver();
	}

	/*
	 * Creates Observer
	 *
	 * @return    {void}
	 */
	createObserver() {
		const self = this;
		const options = {
			root: null,
			rootMargin: '100px',
			threshold: 0.5,
		};

		if (this.selectorEl === 'statistics-block') {
			// eslint-disable-next-line
			const observer = new IntersectionObserver(function (
				entries,
				observer
			) {
				self.handleStatisticsIntersect(entries, observer);
			},
			options);
			observer.observe(this.rootEl);
		}

		if (this.selectorEl === 'hero-banner__property-banner') {
			options.threshold = 0.9;
			// eslint-disable-next-line
			const observer = new IntersectionObserver(function (
				entries,
				observer
			) {
				self.handlePropertyIntersect(entries, observer);
			},
			options);
			observer.observe(this.rootEl);
		}

		if (this.selectorEl === 'career-primary-filter-button') {
			options.threshold = 0.9;
			// eslint-disable-next-line
			const observer = new IntersectionObserver(function (
				entries,
				observer
			) {
				self.handleCareersIntersect(entries, observer);
			},
			options);
			observer.observe(this.rootEl);
		}
	}

	/*
	 * Handles intersection
	 * @param {array} statistic numbers
	 * @return    {void}
	 */
	handleStatisticsIntersect(entries) {
		const self = this;

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const counters = entry.target.querySelectorAll(
					'span.statistics-block__number'
				);
				if (!entry.target.classList.contains('stats-loaded')) {
					self.animateStatistics(counters);
				}
				entry.target.classList.add('stats-loaded');
			}
		});
	}

	/*
	 * Handles intersection
	 * @param {array} property banner element(s)
	 * @return    {void}
	 */
	handlePropertyIntersect(entries) {
		const enquireBtnActive = 'enquire-button-active';
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				document.body.classList.add(enquireBtnActive);
			} else {
				document.body.classList.remove(enquireBtnActive);
			}
		});
	}

	/*
	 * Handles intersection
	 * @param {array} career feed element(s)
	 * @return    {void}
	 */
	handleCareersIntersect(entries) {
		const filterBtnActive = 'career-filter-button-active';
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				document.body.classList.add(filterBtnActive);
			} else {
				document.body.classList.remove(filterBtnActive);
			}
		});
	}

	/*
	 * Animates the statistics, count up from 0
	 * @param {array} statistic numbers
	 * @return    {void}
	 */
	animateStatistics(counters) {
		counters.forEach((counter) => {
			const animate = () => {
				let startTimestamp = null;

				const start = 0,
					end = counter.getAttribute('data-number'),
					duration = 2000;

				const step = (timestamp) => {
					if (!startTimestamp) startTimestamp = timestamp;
					const progress = Math.min(
						(timestamp - startTimestamp) / duration,
						1
					);
					counter.innerHTML = Math.floor(
						progress * (end - start) + start
					);

					if (progress < 1) {
						window.requestAnimationFrame(step);
					} else {
						counter.innerHTML = counter.getAttribute('data-number');
					}
				};

				window.requestAnimationFrame(step);
			};
			animate();
		});
	}
}
